import React, { Component } from 'react'

import ErrorPage from './pages/error/ErrorPage'
import { getAppInsights } from '../services/applicationInsights'
import { environment } from '../config/environment'

const { mode } = environment

class AppErrorBoundary extends Component {
    constructor(props) {
        super(props)
        this.isLocal = mode === 'local'
        this.isTest = mode === 'test'
        this.isDev = mode === 'development'
        this.state = {}
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch(error, errorInfo) {
        if (this.isLocal || this.isTest) {
            // eslint-disable-next-line no-console
            console.log(error, errorInfo)
        } else {
            const appInsights = getAppInsights()
            if (this.isDev) {
                // eslint-disable-next-line no-console
                console.log(error, errorInfo)
            }
            appInsights.trackException({
                exception: error,
                properties: {
                    ...errorInfo,
                },
            })
        }
    }

    render() {
        const { hasError } = this.state
        if (hasError) {
            return <ErrorPage />
        }
        const { children } = this.props
        return children
    }
}

export default AppErrorBoundary
